import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface KioskContextType {
  isKioskMode: boolean;
  setKioskMode: (value: boolean) => void;
}

const KioskContext = createContext<KioskContextType>({
  isKioskMode: false,
  setKioskMode: () => {},
});

export const useKiosk = () => useContext(KioskContext);

export function KioskProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [isKioskMode, setKioskMode] = useState(false);

  // Auto-detect kiosk mode from route or query param
  useEffect(() => {
    const isKioskRoute = location.pathname.startsWith('/kiosk');
    const searchParams = new URLSearchParams(location.search);
    const hasKioskParam = searchParams.get('kiosk') === 'true';
    
    if (isKioskRoute || hasKioskParam) {
      setKioskMode(true);
    }
  }, [location]);

  return (
    <KioskContext.Provider value={{ isKioskMode, setKioskMode }}>
      {children}
    </KioskContext.Provider>
  );
}
